import { WhitelabelActionType } from '../action-types'
import { WhitelabelPayload } from '../actions/whitelabelActions'

export const getWhitelabel = (payload: WhitelabelPayload) => ({
    type: WhitelabelActionType.GET_WHITELABEL,
    payload,
})
